import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import {
  Box, Button, Collapse, FormControl, IconButton, InputLabel, MenuItem,
  Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, Typography, Menu, ListItemIcon, ListItemText, Pagination,
} from '@mui/material';
import { ExpandMore, ExpandLess, Search, Delete, History, MoreVert, List, Add } from '@mui/icons-material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Navbar from '../Layouts/Navbar';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import HistoriqueModal from './HistoriqueModal';



export default function PreReservationTable() {
  const [openhis, setOpenHis] = useState(false);
  const handleOpenHis = () => setOpenHis(true);
  const handleCloseHis = () => setOpenHis(false);
  const navigate = useNavigate()
  const [snack, setSnack] = useState({ open: false, message: '', type: 'success' });
  const handleSnack = (message, type = 'success') => {
    setSnack({ open: true, message, type });
  };
  
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnack({ ...snack, open: false });
  };
  const handleDelete = () => {
    try {
      // 👉 Your actual delete logic (e.g., API call, state update)
      // e.g., await deleteTrajet(selectedTrajet)
  
      // If successful
      handleSnack('Trajet(s) supprimé(s) avec succès', 'success');
    } catch (error) {
      // If there's an error
      handleSnack("Erreur lors de la suppression du trajet", 'error');
    }
  };
  


  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [menuRowId, setMenuRowId] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);

  const rows = [
    {
      id: 1,
      date: '22/03/2025 11:17',
      zone: 'ZONE 14: SIDI YOUSSEF',
      employe: 'TEST Younouss BOUREGBA',
      trajet: ['→ ZONE 14: SIDI YOUSSEF - AIN ITTI', '← ZONE 14: SIDI YOUSSEF - AIN ITTI'],
      ramassage: ['→ 04.SYBA - MSALLA', '← 04.SYBA - MSALLA'],
      adresse: ['→', '←'],
      heure: ['→ 8', '← 17'],
    },
    // ADD MORE ROWS TO TEST PAGINATION
    { id: 2, date: '23/03/2025 10:00', zone: 'ZONE 15', employe: 'John Doe', trajet: ['→ A', '← A'], ramassage: ['→ X', '← X'], adresse: ['→', '←'], heure: ['→ 9', '← 18'] },
    { id: 3, date: '24/03/2025 09:30', zone: 'ZONE 16', employe: 'Jane Doe', trajet: ['→ B', '← B'], ramassage: ['→ Y', '← Y'], adresse: ['→', '←'], heure: ['→ 10', '← 19'] },
    { id: 4, date: '25/03/2025 08:45', zone: 'ZONE 17', employe: 'Alex Smith', trajet: ['→ C', '← C'], ramassage: ['→ Z', '← Z'], adresse: ['→', '←'], heure: ['→ 7', '← 16'] },
    { id: 5, date: '26/03/2025 11:00', zone: 'ZONE 18', employe: 'Sara Lee', trajet: ['→ D', '← D'], ramassage: ['→ W', '← W'], adresse: ['→', '←'], heure: ['→ 8', '← 17'] },
    { id: 6, date: '27/03/2025 14:20', zone: 'ZONE 19', employe: 'Chris Evans', trajet: ['→ E', '← E'], ramassage: ['→ V', '← V'], adresse: ['→', '←'], heure: ['→ 10', '← 18'] },
    { id: 7, date: '27/03/2025 14:20', zone: 'ZONE 19', employe: 'Chris Evans', trajet: ['→ E', '← E'], ramassage: ['→ V', '← V'], adresse: ['→', '←'], heure: ['→ 10', '← 18'] },
    { id: 8, date: '27/03/2025 14:20', zone: 'ZONE 19', employe: 'Chris Evans', trajet: ['→ E', '← E'], ramassage: ['→ V', '← V'], adresse: ['→', '←'], heure: ['→ 10', '← 18'] },
    { id: 9, date: '27/03/2025 14:20', zone: 'ZONE 19', employe: 'Chris Evans', trajet: ['→ E', '← E'], ramassage: ['→ V', '← V'], adresse: ['→', '←'], heure: ['→ 10', '← 18'] },
    { id: 10, date: '27/03/2025 14:20', zone: 'ZONE 19', employe: 'Chris Evans', trajet: ['→ E', '← E'], ramassage: ['→ V', '← V'], adresse: ['→', '←'], heure: ['→ 10', '← 18'] },
    { id: 11, date: '27/03/2025 14:20', zone: 'ZONE 19', employe: 'Chris Evans', trajet: ['→ E', '← E'], ramassage: ['→ V', '← V'], adresse: ['→', '←'], heure: ['→ 10', '← 18'] },
    { id: 12, date: '27/03/2025 14:20', zone: 'ZONE 19', employe: 'Chris Evans', trajet: ['→ E', '← E'], ramassage: ['→ V', '← V'], adresse: ['→', '←'], heure: ['→ 10', '← 18'] },
    { id: 13, date: '27/03/2025 14:20', zone: 'ZONE 19', employe: 'Chris Evans', trajet: ['→ E', '← E'], ramassage: ['→ V', '← V'], adresse: ['→', '←'], heure: ['→ 10', '← 18'] },

  ];

  const handleMenuClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1); // reset to first page when rows per page change
  };

  const paginatedRows = rows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCount = Math.ceil(rows.length / rowsPerPage);

  return (
    <Box>
      <Navbar />
      <Box p={2}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <CalendarMonthIcon />
            <Typography variant="h6">PRÉ-RÉSERVATIONS</Typography>
          </Box>
           <Box display="flex" gap={2}>
          <Button variant="outlined" sx={{
            color: 'red',
            borderColor: 'red',
            textTransform: 'none',
            '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
          }} onClick={()=>navigate('/add-pre-reservation')} startIcon={<Add />}>Ajouter</Button>
          <Button variant="outlined" sx={{
            color: 'red',
            borderColor: 'red',
            textTransform: 'none',
            '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
          }} startIcon={<InsertDriveFileIcon />}>Exporter</Button>
          </Box>
        </Box>

        {/* Search Section */}
        <Paper variant="outlined" sx={{ mb: 3 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1} mt={1} onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <Search />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>RECHERCHER</Typography>
            <IconButton>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
          </Box>
        </Paper>

        <Collapse in={open}>
          <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
            <Box display="flex" gap={2} mb={2}>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Société</InputLabel>
                <Select label="Société">
                  <MenuItem value="Société 1">Société 1</MenuItem>
                  <MenuItem value="Société 2">Société 2</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Zone</InputLabel>
                <Select label="Zone">
                  <MenuItem value="Zone 1">Zone 1</MenuItem>
                  <MenuItem value="Zone 2">Zone 2</MenuItem>
                </Select>
              </FormControl>
              <TextField
                type="date"
                label="Date"
                InputLabelProps={{ shrink: true }}
                fullWidth size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  },
                  '& .MuiInputLabel-root': {
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                  }
                }}
              />
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Statut</InputLabel>
                <Select label="Statut">
                  <MenuItem value="En cours">En cours</MenuItem>
                  <MenuItem value="Terminé">Terminé</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Button variant="outlined" sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}>Reset</Button>
              <Button variant="outlined" sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}>Search</Button>
            </Box>
          </Paper>
        </Collapse>

        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Zone</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Employé</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Trajet</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Point de ramassage</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Adresse</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Heure</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRows.map((row, index) => (
                <TableRow key={row.id} hover>
                  <TableCell>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                  <TableCell>{row.date}</TableCell>
                  <TableCell>{row.zone}</TableCell>
                  <TableCell>{row.employe}</TableCell>
                  <TableCell>{row.trajet.map((t, i) => (<Typography key={i}>{t}</Typography>))}</TableCell>
                  <TableCell>{row.ramassage.map((r, i) => (<Typography key={i}>{r}</Typography>))}</TableCell>
                  <TableCell>{row.adresse.map((a, i) => (<Typography key={i}>{a}</Typography>))}</TableCell>
                  <TableCell>{row.heure.map((h, i) => (<Typography key={i}>{h}</Typography>))}</TableCell>
                  <TableCell>
                    <IconButton onClick={(e) => handleMenuClick(e, row.id)}>
                      <MoreVert />
                    </IconButton>
                    <Menu anchorEl={anchorEl} open={menuRowId === row.id && openMenu} onClose={handleMenuClose} PaperProps={{
                      sx: {
                        minWidth: "200px",
                        "& .MuiMenuItem-root": {
                          color: "black",
                          "& .MuiListItemIcon-root": {
                            color: "black",
                          },
                          "&:hover": {
                            backgroundColor: "red",
                            color: "white",
                            "& .MuiListItemIcon-root": {
                              color: "white",
                            },
                          },
                        },
                      },
                    }}>
                      <MenuItem component={Link} to="/pre-reservation-detail">
                        <ListItemIcon><List fontSize="small" /></ListItemIcon>
                        <ListItemText>Détail</ListItemText>
                      </MenuItem>
                      <MenuItem sx={{ color: 'red' }}>
                        <ListItemIcon sx={{ color: 'red' }}><History fontSize="small" /></ListItemIcon>
                        <ListItemText  onClick={handleOpenHis}>Historique</ListItemText>
                        <HistoriqueModal open={openhis} handleClose={handleCloseHis} />
                      </MenuItem>
                      <MenuItem>
                        <ListItemIcon><Delete fontSize="small" /></ListItemIcon>
                        <ListItemText onClick={handleDelete}>Supprimer</ListItemText>
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination + entries info */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography>{rows.length} entrées</Typography>
          <Box display="flex" gap={2} alignItems="center">
            <FormControl size="small" sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#000' },
                '&.Mui-focused fieldset': { borderColor: 'red' },
              }
            }}>
              <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </Box>

      </Box>
      <Snackbar open={snack.open} autoHideDuration={3000} onClose={handleCloseSnack} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
  <MuiAlert onClose={handleCloseSnack} severity={snack.type} elevation={6} variant="filled" sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}>
    {snack.message}
  </MuiAlert>
</Snackbar>

    </Box>

    
  );
}
